import React from 'react';
import moment from 'moment';
import { sortBy } from 'lodash';

import { fileDownload } from '../../../../../../common/services/fileUtils';
import { getHistoryExportData, getRealTimeExportData, getRealTimeExportDemoData } from '../../helper';
import { GraphControls } from './styles';
import { TimeFormatType } from '../../../../../../common/components/TimeFormat/TimeFormat';
import Button, { ExportIcon } from '../../../../../../common/components/Button/Button';

function ExportComponent({ dates, metric, chargerMetrics, offset, isRealTime, isDemo }) {
  const onExport = () => {
    const today = moment().format('YYYY-MM-DD_HH-mm-ss');
    const filename = `${Array.isArray(metric) ? 'Consolidated_Telemetry' : metric.title}_${today}.csv`;

    const timeUTCorUSER = offset === 0 ? TimeFormatType.UTC : TimeFormatType.USER;
    const metrics = Array.isArray(metric) ? metric : [metric];

    const rawData = isRealTime
      ? isDemo
        ? getRealTimeExportDemoData([], dates, chargerMetrics, metrics, offset)
        : getRealTimeExportData([], dates, chargerMetrics, metrics, offset)
      : getHistoryExportData([], chargerMetrics, metrics, offset);

    const csvData = isRealTime ? sortBy(rawData, 'ts') : sortBy(rawData, ['ts', 'agg']);

    const timestampIndex = {};

    csvData.forEach((item) => {
      const key = isRealTime ? item.ts : `${item.ts}_${item.agg}`;

      if (!timestampIndex[key]) {
        timestampIndex[key] = { ts: item.ts };

        if (!isRealTime) timestampIndex[key].agg = item.agg;
      }

      timestampIndex[key][item.metricTitle] = item.value;
    });

    const formattedData = Object.values(timestampIndex).map((row) =>
      isRealTime
        ? [row.ts, ...metrics.map(({ title }) => row[title] || '')]
        : [row.ts, row.agg, ...metrics.map(({ title }) => row[title] || '')],
    );

    const header = isRealTime
      ? [`Time Stamp (${timeUTCorUSER})`, ...metrics.map(({ title, units }) => `${title} (${units})`)]
      : [`Time Stamp (${timeUTCorUSER})`, 'Aggregation', ...metrics.map(({ title, units }) => `${title} (${units})`)];

    formattedData.unshift(header);

    fileDownload(formattedData.join('\n'), filename.replaceAll(' ', '_'), 'text/csv');
  };

  return (
    <GraphControls>
      <Button variant="contained" onClick={onExport}>
        <ExportIcon /> Export
      </Button>
    </GraphControls>
  );
}

export default ExportComponent;
